import { Item, OptContent, OptWrapper } from './styles'

const ItemOption = ({ children, handleClick, bg, border, borderColor, color, disabled, id, handleMouseOver, handleMouseOut, input, title }:any) => {
  return (
    <OptWrapper>
      <Item
        disabled={disabled}
        onClick={handleClick}
        borderColor={borderColor}
        border={border}
        bg={bg}
        color={color}
        id={id}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        input={input}
        title={title}
      >
        <OptContent>{children}</OptContent>
      </Item>
    </OptWrapper>
  )
}

export default ItemOption
